module.exports = __webpack_public_path__ + "img/x.308e3fdc.svg";